import { render, staticRenderFns } from "./confidentiality.vue?vue&type=template&id=3090fa85&scoped=true"
import script from "./confidentiality.vue?vue&type=script&lang=js"
export * from "./confidentiality.vue?vue&type=script&lang=js"
import style0 from "./confidentiality.vue?vue&type=style&index=0&id=3090fa85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090fa85",
  null
  
)

export default component.exports